import { isAndroid } from 'functions/isAndroid';
import { isIOS } from 'functions/isIOS';
import { javaApiInstance } from 'functions/request';
import CConsole from 'functions/CConsole';

export const getKarmaEarnRedirectUrl = async (userId, karmaEarnId, aloomaSource) => {
  const platform = (() => {
    if (isAndroid()) return 'android';
    if (isIOS()) return 'ios';

    return 'web';
  })();
  const params = { source: aloomaSource, platform, user_id: userId };
  const response = await javaApiInstance.get(`/api/karmaearn/offer_links/${karmaEarnId}`, { params });

  return response?.data?.url;
};

export const processKarmaEarnRedirect = async (userId, karmaEarnId, aloomaSource, errorHandler) => {
  try {
    const url = await getKarmaEarnRedirectUrl(userId, karmaEarnId, aloomaSource);

    if (!url) {
      errorHandler('Something went wrong, try another game');

      return;
    }

    window.location.href = url;
  } catch (e) {
    const message = e?.data?.message || 'Something went wrong, try another game';

    CConsole.error(e);
    errorHandler(message.replace(/:/g, '-'));
  }
};
